import { Flex } from "@chakra-ui/react";
import PopoverTagColumn from "components/Column/PopoverTagDisplay";
import { PathTag } from "components/Tag/BasePathTag";
import { PathId } from "features/Path/models";
import { Template } from "features/Resources/SharedTemplate/models";
import { Text14 } from "components/Text";
import { pluralize } from "helpers/string";

function PathCountBadge({ count }: { count: number }) {
  return (
    <Text14 bg="bg.muted" py="1" px="2" borderRadius="md">{count} {pluralize("Path", count)}</Text14>
  );
}

const renderPathCountBadge = (items: PathId[]) => <PathCountBadge count={items.length} />;
const renderPathTag = (pathId: PathId) => <PathTag pathId={pathId} size="sm" />;
const getPathKey = (pathId: PathId) => pathId;

export function ListTemplatePaths({ pathIds }: { pathIds: PathId[] }) {
  return (
    <PopoverTagColumn<PathId>
      items={pathIds ?? []}
      renderTag={renderPathTag}
      displaySummary={(items) => renderPathCountBadge(items)}
      keyFn={getPathKey}
      emptyLabel="No Paths"
    />
  );
}

export function DisplayTemplatePaths({ template }: { template: Template }) {
  if (!template?.pathIds) {
    return "None";
  }
  const pathIds = template?.pathIds ?? [];
  return (
    <Flex align="center" gap="1">
      <ListTemplatePaths pathIds={pathIds} />
    </Flex>
  );
}
